<div
  class="saved-payment-methods-container"
  [class.non-default-only]="
    displayMode() === 'selected-excluded' || displayMode() === 'non-default-only'
  "
  [class.accordion-mode]="accordionMode()"
>
  @if (!accordionMode()) {
    @for (paymentMethod of displayedPaymentMethods(); track paymentMethod._id) {
      <button
        class="payment-card default-button"
        [class.selected]="effectiveSelectedId() === paymentMethod._id"
        [class.default-only]="displayMode() === 'selected-only' || displayMode() === 'default-only'"
        (click)="onPaymentMethodSelect(paymentMethod)"
      >
        <div class="left-column">
          <div class="brand">
            <img
              [src]="getBrandLogoUrl(paymentMethod.paymentMethodBrand)"
              [alt]="paymentMethod.paymentMethodBrand"
              [class]="paymentMethod.paymentMethodBrand + '-logo'"
            />
          </div>

          <div class="details">
            <p class="title primary-font-semibold">
              {{ 'billing_and_payments.card_ending_with' | translate }}
              {{ paymentMethod.paymentMethodLast4digits }}
            </p>
            <p class="expiry primary-font-medium">
              {{ 'billing_and_payments.expires_on' | translate }}
              {{ formatExpiry(paymentMethod.paymentMethodExpiry) }}
            </p>
          </div>
        </div>

        <div class="right-column">
          @if (paymentMethod.default) {
            <div class="default-badge">
              <span class="primary-font-medium default-badge-text">{{
                'billing_and_payments.default_card' | translate
              }}</span>
            </div>
          }

          <div class="radio-button-container">
            <input
              type="radio"
              name="paymentMethod"
              [checked]="effectiveSelectedId() === paymentMethod._id"
              [id]="'paymentMethod-' + paymentMethod._id"
              [value]="paymentMethod._id"
              (change)="onPaymentMethodSelect(paymentMethod)"
            />
            <span class="checkmark"></span>
          </div>
        </div>
      </button>
    }
  } @else {
    <div class="accordion" id="savedPaymentMethodsAccordion">
      @for (paymentMethod of displayedPaymentMethods(); track paymentMethod._id) {
        <div
          class="accordion-item"
          [class.accordion-item-expanded]="expandedId() === paymentMethod._id"
        >
          <div class="accordion-header" [id]="'heading-' + paymentMethod._id">
            <button
              class="accordion-button default-button payment-card"
              [class.collapsed]="expandedId() !== paymentMethod._id"
              type="button"
              (click)="toggleAccordion(paymentMethod._id)"
              [attr.aria-expanded]="expandedId() === paymentMethod._id"
              [attr.aria-controls]="'collapse-' + paymentMethod._id"
            >
              <div class="left-column">
                <div class="brand">
                  <img
                    [src]="getBrandLogoUrl(paymentMethod.paymentMethodBrand)"
                    [alt]="paymentMethod.paymentMethodBrand"
                    [class]="paymentMethod.paymentMethodBrand + '-logo'"
                  />
                </div>

                <div class="details">
                  <p class="title primary-font-semibold">
                    {{ 'billing_and_payments.card_ending_with' | translate }}
                    {{ paymentMethod.paymentMethodLast4digits }}
                  </p>
                  <p class="expiry primary-font-medium">
                    {{ 'billing_and_payments.expires_on' | translate }}
                    {{ formatExpiry(paymentMethod.paymentMethodExpiry) }}
                  </p>
                </div>
              </div>
              <div class="right-column">
                @if (paymentMethod.default) {
                  <div class="default-badge">
                    <span class="primary-font-regular default-badge-text">{{
                      'billing_and_payments.default_card' | translate
                    }}</span>
                  </div>
                }

                <span class="accordion-chevron">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="8"
                    viewBox="0 0 14 8"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M7.37629 7.37629C7.18876 7.56376 6.93445 7.66907 6.66929 7.66907C6.40412 7.66907 6.14982 7.56376 5.96229 7.37629L0.305288 1.71929C0.209778 1.62704 0.133596 1.5167 0.0811869 1.39469C0.0287779 1.27269 0.00119157 1.14147 3.77564e-05 1.00869C-0.00111606 0.87591 0.0241859 0.744231 0.0744668 0.621335C0.124748 0.498438 0.199001 0.386786 0.292893 0.292893C0.386786 0.199 0.498438 0.124747 0.621334 0.0744663C0.744231 0.0241854 0.87591 -0.00111606 1.00869 3.7757e-05C1.14147 0.00119157 1.27269 0.0287779 1.39469 0.0811869C1.5167 0.133596 1.62704 0.209778 1.71929 0.305288L6.66929 5.25529L11.6193 0.305288C11.8079 0.12313 12.0605 0.0223355 12.3227 0.0246139C12.5849 0.0268924 12.8357 0.132061 13.0211 0.317469C13.2065 0.502877 13.3117 0.75369 13.314 1.01589C13.3162 1.27808 13.2154 1.53069 13.0333 1.71929L7.37629 7.37629Z"
                      fill="black"
                    />
                  </svg>
                </span>
              </div>
            </button>
          </div>
          <div
            class="accordion-collapse collapse"
            [class.show]="expandedId() === paymentMethod._id"
            [id]="'collapse-' + paymentMethod._id"
            [attr.aria-labelledby]="'heading-' + paymentMethod._id"
          >
            <div class="accordion-body">
              <div class="button-container">
                @if (!paymentMethod.default) {
                  <button
                    class="default-button set-default-button primary-font-medium"
                    (click)="
                      onPaymentMethodAction('set-default', paymentMethod); $event.stopPropagation()
                    "
                  >
                    <span class="icon-container">
                      <svg
                        class="rtl"
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="15"
                        viewBox="0 0 16 15"
                        fill="none"
                      >
                        <path
                          d="M7.72467 0.75L9.794 5.23533L14.6993 5.81733L11.0727 9.17067L12.0353 14.016L7.72467 11.6033L3.414 14.0167L4.37667 9.17133L0.75 5.81667L5.656 5.23467L7.72467 0.75Z"
                          stroke="black"
                          stroke-width="1.5"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                    {{ 'billing_and_payments.set_as_default' | translate }}
                  </button>
                }
                <button
                  class="default-button primary-font-medium delete-card-button"
                  (click)="onPaymentMethodAction('delete', paymentMethod); $event.stopPropagation()"
                >
                  <span class="icon-container">
                    <svg
                      class="rtl"
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="15"
                      viewBox="0 0 14 15"
                      fill="none"
                    >
                      <path
                        d="M9.41667 3.41667V2.88333C9.41667 2.1366 9.41667 1.76323 9.27134 1.47801C9.14351 1.22713 8.93954 1.02316 8.68865 0.895325C8.40344 0.75 8.03007 0.75 7.28333 0.75H6.21667C5.46993 0.75 5.09656 0.75 4.81135 0.895325C4.56046 1.02316 4.35649 1.22713 4.22866 1.47801C4.08333 1.76323 4.08333 2.1366 4.08333 2.88333V3.41667M5.41667 7.08333V10.4167M8.08333 7.08333V10.4167M0.75 3.41667H12.75M11.4167 3.41667V10.8833C11.4167 12.0034 11.4167 12.5635 11.1987 12.9913C11.0069 13.3676 10.701 13.6736 10.3246 13.8653C9.89682 14.0833 9.33677 14.0833 8.21667 14.0833H5.28333C4.16323 14.0833 3.60318 14.0833 3.17535 13.8653C2.79903 13.6736 2.49307 13.3676 2.30132 12.9913C2.08333 12.5635 2.08333 12.0034 2.08333 10.8833V3.41667"
                        stroke="#DA2F2F"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                  {{ 'billing_and_payments.delete_card' | translate }}
                </button>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>
